import type { FC, PropsWithChildren } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import clsx from "clsx";

import styles from "./styles.module.scss";

type ShimmerProps = {
  className?: string;
  height?: string | number;
  width?: string | number;
};

export const Shimmer: FC<PropsWithChildren<ShimmerProps>> = ({
  className,
  children,
  height,
  width,
}) => {
  const [block, cn] = useModuleBEM(styles, "Shimmer");

  return (
    <div
      className={clsx(block, className)}
      style={height || width ? { height, width } : undefined}
    >
      <div className={cn("cover")}>{children}</div>
    </div>
  );
};
